export const shareIcon = { size: '80', color: '#057a83' };
export const close = { size: '24', color: '#ffffff' };
export const linkAction = { size: '20', color: '#057a83' };
